// extracted by mini-css-extract-plugin
module.exports = {"uikit-image":"uikit-image__W6cSQ","uikit-image--accessory":"uikit-image--accessory__xfSNy","uikit-image--context":"uikit-image--context__3myst"};